import { render, staticRenderFns } from "./PremiumIdInfo.vue?vue&type=template&id=50b64f66&scoped=true&"
import script from "./PremiumIdInfo.vue?vue&type=script&lang=js&"
export * from "./PremiumIdInfo.vue?vue&type=script&lang=js&"
import style0 from "./PremiumIdInfo.vue?vue&type=style&index=0&id=50b64f66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b64f66",
  null
  
)

export default component.exports